module.exports = __webpack_public_path__ + "img/1-3.5b5f2478.svg";